import appConfig from '@configs/appConfig';
import getData from '@services/api/common/getData';

const resource = '/Chat';

export const getPusherConfig = () =>
  getData(`${appConfig.baseUrl}${resource}/getPusherSettings`);

export default {};
